import type { DifficultyId } from "./types";

export type TutorialStep = "aim" | "throw" | "ammo" | "reload" | "lives" | "combo" | "gold" | "done" | null;

export const TUTORIAL_ORDER: Exclude<TutorialStep, null>[] = [
  "aim",
  "throw",
  "ammo",
  "reload",
  "lives",
  "combo",
  "gold",
  "done",
];

export function tutorialAfterNext(step: TutorialStep): TutorialStep {
  if (!step || step === "done") return "done";
  const i = TUTORIAL_ORDER.indexOf(step);
  return TUTORIAL_ORDER[i + 1] ?? "done";
}

export function tutorialAfterSkip(): { tutorial: null; seen: true } {
  return { tutorial: null, seen: true };
}

export function hudButtonAction(act: string | undefined): "pause" | "tut-next" | "tut-skip" | null {
  if (act === "pause" || act === "tut-next" || act === "tut-skip") return act;
  return null;
}

export type PauseKind = "playing" | "paused" | "countdown";

export interface PauseFlow {
  kind: PauseKind;
  countdown: number;
  frozen: boolean;
}

export function openPause(_state: PauseFlow): PauseFlow {
  return { kind: "paused", countdown: 0, frozen: true };
}

export function resumePause(_state: PauseFlow): PauseFlow {
  return { kind: "countdown", countdown: 3, frozen: true };
}

export function tickPauseCountdown(state: PauseFlow, dt: number): PauseFlow {
  if (state.kind !== "countdown") return state;
  const countdown = state.countdown - dt;
  if (countdown <= 0) return { kind: "playing", countdown: 0, frozen: false };
  return { kind: "countdown", countdown, frozen: true };
}

export function canOpenPause(scene: string, gameOver: boolean): boolean {
  return !gameOver && (scene === "play" || scene === "tutorial" || scene === "pause");
}

export function closePauseToCountdown(): PauseFlow {
  return resumePause({ kind: "paused", countdown: 0, frozen: true });
}

export function gameOverCheerKind(score: number, record: boolean): "record" | "great" | "good" | "ok" {
  if (record) return "record";
  if (score >= 2500) return "great";
  if (score >= 800) return "good";
  return "ok";
}

export function difficultyFromSlider(value: number): DifficultyId {
  if (value <= 0) return "easy";
  if (value >= 2) return "hard";
  return "normal";
}

export function sliderFromDifficulty(id: DifficultyId): number {
  if (id === "easy") return 0;
  if (id === "hard") return 2;
  return 1;
}

export function boardTitleKey(id: DifficultyId): "boardEasy" | "boardNormal" | "boardHard" {
  if (id === "easy") return "boardEasy";
  if (id === "hard") return "boardHard";
  return "boardNormal";
}
